import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PaymentModal from '../components/PaymentModal';

function Dashboard() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('unet_user');
    if (user) {
      setUserData(JSON.parse(user));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  if (!userData) {
    return <div className="error">Usuário não autenticado</div>;
  }

  // Função para copiar código PIX
  const copyPixCode = async () => {
    const pixCode = '00020126580014BR.GOV.BCB.PIX0136123e4567-e12b-12d1-a456-426614174000520400005303986540599.905802BR5913UNET BANDA LARGA6008CAMPOS62070503***6304E2CA';
    try {
      await navigator.clipboard.writeText(pixCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback para navegadores mais antigos
      const textArea = document.createElement('textarea');
      textArea.value = pixCode;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Dados da fatura atual para o modal
  const faturaAtual = {
    mes: 'Março 2025',
    valor: 88.00,
    vencimento: '15/03/2025',
    status: 'Pendente',
    codigo: 'FAT003'
  };

  return (
    <div className="dashboard-page">
      <div className="container">
        <div className="dashboard-header">
          <h1>Bem-vindo, {userData.nome}!</h1>
          <p>Gerencie sua conta e acompanhe seus serviços</p>
        </div>

        <div className="dashboard-grid">
          {/* Status do Plano */}
          <div className="dashboard-card status-card">
            <div className="card-header">
              <h3>Status do Plano</h3>
              <span className={`status-badge ${userData.status.toLowerCase()}`}>
                {userData.status}
              </span>
            </div>
            <div className="card-content">
              <div className="plan-info">
                <h4>{userData.plano}</h4>
                <p>Vencimento: {userData.vencimento}</p>
              </div>
              <div className="plan-actions">
                <Link to="/central/planos" className="btn-secondary">Ver Planos</Link>
                <Link to="/central/faturas" className="btn-primary">Ver Faturas</Link>
              </div>
            </div>
          </div>

          {/* Resumo Financeiro */}
          <div className="dashboard-card finance-card">
            <div className="card-header">
              <h3>Resumo Financeiro</h3>
            </div>
            <div className="card-content">
              <div className="finance-item">
                <span className="label">Fatura Atual:</span>
                <span className="value">R$ 88,00</span>
              </div>
              <div className="finance-item">
                <span className="label">Vencimento:</span>
                <span className="value">15/02/2025</span>
              </div>
              <div className="finance-item">
                <span className="label">Status:</span>
                <span className="value pending">A vencer</span>
              </div>
              <div className="finance-actions">
                <button 
                  className={`btn-pix ${copied ? 'copied' : ''}`}
                  onClick={copyPixCode}
                >
                  {copied ? (
                    <>
                      <i className="fas fa-check"></i>
                      PIX Copiado!
                    </>
                  ) : (
                    <>
                      <i className="fas fa-qrcode"></i>
                      Copiar PIX
                    </>
                  )}
                </button>
                <button 
                  className="btn-primary"
                  onClick={() => setShowPaymentModal(true)}
                >
                  Pagar Agora
                </button>
              </div>
              <Link to="/central/faturas" className="btn-secondary">Ver Todas as Faturas</Link>
            </div>
          </div>

          {/* Ações Rápidas */}
          <div className="dashboard-card actions-card">
            <div className="card-header">
              <h3>Ações Rápidas</h3>
            </div>
            <div className="card-content">
              <div className="quick-actions">
                <Link to="/central/faturas" className="action-item">
                  <i className="fas fa-file-invoice"></i>
                  <span>Minhas Faturas</span>
                </Link>
                <Link to="/central/suporte" className="action-item">
                  <i className="fas fa-headset"></i>
                  <span>Suporte</span>
                </Link>
                <Link to="/central/perfil" className="action-item">
                  <i className="fas fa-user"></i>
                  <span>Meu Perfil</span>
                </Link>
                <Link to="/central/alterar-senha" className="action-item">
                  <i className="fas fa-key"></i>
                  <span>Alterar Senha</span>
                </Link>
              </div>
            </div>
          </div>

          {/* Notificações */}
          <div className="dashboard-card notifications-card">
            <div className="card-header">
              <h3>Notificações</h3>
              <Link to="/central/notificacoes" className="view-all">Ver todas</Link>
            </div>
            <div className="card-content">
              <div className="notification-item">
                <div className="notification-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="notification-content">
                  <h4>Fatura Paga</h4>
                  <p>Sua fatura de janeiro foi paga com sucesso.</p>
                  <span className="notification-time">Há 2 dias</span>
                </div>
              </div>
              <div className="notification-item">
                <div className="notification-icon">
                  <i className="fas fa-info-circle"></i>
                </div>
                <div className="notification-content">
                  <h4>Manutenção Programada</h4>
                  <p>Manutenção agendada para 20/02/2025 às 02:00h.</p>
                  <span className="notification-time">Há 5 dias</span>
                </div>
              </div>
            </div>
          </div>

          {/* Estatísticas de Uso */}
          <div className="dashboard-card usage-card">
            <div className="card-header">
              <h3>Uso da Internet</h3>
            </div>
            <div className="card-content">
              <div className="usage-stats">
                <div className="usage-item">
                  <span className="label">Download</span>
                  <div className="usage-bar">
                    <div className="usage-fill" style={{width: '75%'}}></div>
                  </div>
                  <span className="value">75%</span>
                </div>
                <div className="usage-item">
                  <span className="label">Upload</span>
                  <div className="usage-bar">
                    <div className="usage-fill" style={{width: '45%'}}></div>
                  </div>
                  <span className="value">45%</span>
                </div>
              </div>
              <p className="usage-note">Dados do mês atual</p>
            </div>
          </div>

          {/* Suporte */}
          <div className="dashboard-card support-card">
            <div className="card-header">
              <h3>Precisa de Ajuda?</h3>
            </div>
            <div className="card-content">
              <p>Nossa equipe está disponível 24h para te ajudar.</p>
              <div className="support-actions">
                <Link to="/central/suporte" className="btn-primary">Abrir Chamado</Link>
                <a href="https://wa.me/5522999611338" target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
                  <i className="fab fa-whatsapp"></i> WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Pagamento */}
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        fatura={faturaAtual}
      />
    </div>
  );
}

export default Dashboard; 